import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { TeamForm } from "./TeamForm";
import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";

export const CreateTeamDialog = ({ tenantId }: { tenantId: string }) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = () => setOpen(!open);
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild className="flex flex-row gap-2 p-2">
        <CreateTriggerButton />
      </DialogTrigger>
      <DialogContent preventClickout preventEscape>
        <DialogHeader>
          <DialogTitle>Create a New Team</DialogTitle>
        </DialogHeader>
        <TeamForm
          tenantId={tenantId}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
